export class Countries {
    countryId: number;
    countryName;
    countryRateId: number;
    warehouseId: number;
    fromInfo: number;
    toInfo: number;
    rate: number;
    warehouse: any;
    createdDate: Date;
    createdBy: number;
    modifiedDate: Date;
    modifiedBy: number;
    isActive: boolean;
    countryCode: string;
    phoneCode: number;
    welcomeTitle: string;
    specialNotes: string;
    generalOverViewStmt: string;
    transitTimeDesc: string;
    customsDutyInfo: string;
    services: string;
    flagUrl: string;
    isDirectServiceAvailable: boolean;
    isConsoServiceAvailable: boolean;
    countryRates: CountryRates[];
    countryWarehouseMapping: CountryWarehouseMapping[]
}

export class CountryRates {
    countryRateId: number
    countryId: number
    warehouseId: number
    fromInfo: number
    toInfo: number
}

export class CountryWarehouseMapping {
    CountryWarehouseMappingId: number
    CountryId: number
    WarehouseId: number
    PackageHandlingFee: number
    OutSideDeliverySurcharges: number
    oSDSurchargeWeight: number
}
